import { StarFilledIcon as CentralStarFilledIcon } from "@wags/ui/product-icons.tsx";
import {
    ExpandableText,
    ExpandableTextButton,
    ExpandableTextContent,
} from "@wags/ui/expandable-text.tsx";
import { VercelImage } from "@wags/ui/vercel-image.tsx";

export function RatingStars({ rating }: { rating: number }) {
    const filled = Math.round(rating);
    return (
        <span
            role="img"
            className="flex items-center gap-0.5"
            aria-label={`Rated ${rating} out of 5`}
        >
            {[0, 1, 2, 3, 4].map((index) => (
                <CentralStarFilledIcon
                    key={index}
                    aria-hidden="true"
                    className={
                        index < filled
                            ? "size-3.5 shrink-0 text-labrador-yellow"
                            : "size-3.5 shrink-0 text-doberman-black/15"
                    }
                />
            ))}
        </span>
    );
}

export function ReviewCard({
    author,
    timeAgo,
    text,
    context,
    photoUrl,
    rating,
}: {
    author: string;
    timeAgo: string;
    text: string;
    context: string;
    photoUrl?: string | null;
    rating?: number | null;
}) {
    return (
        <div className="flex flex-col gap-3 rounded-card border-shadow bg-true-white p-card">
            <div className="flex items-center gap-3">
                {photoUrl ? (
                    <VercelImage
                        src={photoUrl}
                        alt={author}
                        width={36}
                        height={36}
                        className="size-9 shrink-0 rounded-full object-cover"
                    />
                ) : (
                    <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-havanese text-body-small font-medium text-doberman-black">
                        {author
                            .split(" ")
                            .filter((w) => /^[a-zA-Z]/.test(w))
                            .map((w) => w[0])
                            .slice(0, 2)
                            .join("")}
                    </div>
                )}
                <div>
                    <div className="flex items-center gap-2">
                        <p className="text-label text-doberman-black">
                            {author}
                        </p>
                        {rating != null && <RatingStars rating={rating} />}
                    </div>
                    {(context || timeAgo) && (
                        <p className="text-body-small text-doberman-black/50">
                            {[context, timeAgo].filter(Boolean).join(" · ")}
                        </p>
                    )}
                </div>
            </div>
            <ExpandableText maxLines={4}>
                <ExpandableTextContent className="text-body-small text-doberman-black/80">
                    {text}
                </ExpandableTextContent>
                <ExpandableTextButton className="mt-2 self-start text-body-small font-medium text-doberman-black/50 hover:text-doberman-black/70 transition-colors" />
            </ExpandableText>
        </div>
    );
}
